import type { Plan } from "@/redux/api/plans.rtkq";
import { cn } from "@/lib/utils";

interface PlanNativeSelectProps {
  value?: string;
  plans: Plan[];
  onChange: (planId: string) => void;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  formatLabel?: (plan: Plan) => string;
}

/** Native select — Radix Select portals crash in React 19 inside tables/dialogs. */
const PlanNativeSelect = ({
  value,
  plans,
  onChange,
  disabled,
  className,
  placeholder = "—",
  formatLabel,
}: PlanNativeSelectProps) => {
  return (
    <select
      dir="rtl"
      disabled={disabled}
      className={cn(
        "h-8 min-w-[10rem] max-w-[16rem] rounded-md border border-input bg-background px-2 text-sm text-foreground disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      value={value || ""}
      onChange={(e) => {
        const next = e.target.value;
        if (!next || next === value) return;
        onChange(next);
      }}
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {plans
        .filter((p) => p.planId)
        .map((p) => (
          <option key={p.planId} value={p.planId}>
            {formatLabel ? formatLabel(p) : p.name || p.internalName}
          </option>
        ))}
    </select>
  );
};

export default PlanNativeSelect;
